/**
 * "Muted" chip (#133, operator-cop-doctrine §3A.5 "muted" state). A small, visible
 * marker that a class-level mute is active — the anomaly class is suppressed from
 * view but NOT lost from data. Rendered in the Anomaly Queue header and beside the
 * muted toggle in the Layer panel so a shelved class survives a shift handover.
 */
export function MutedChip({ label = 'muted' }: { label?: string }): JSX.Element {
  return (
    <span
      data-testid="muted-chip"
      className="inline-flex items-center gap-1 text-[9px] font-medium px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-300 border border-amber-500/30 whitespace-nowrap"
      title="A class-level mute is active — the data is retained, just hidden from view"
    >
      🔇 {label}
    </span>
  );
}
